// Where an enrollment originated. See ClickUp 868jxkz4p §3. Built from the
// caller's `t` so the labels follow the active language.
export const getEnrollmentSources = (t) => [
  { id: "application", label: t("enrollmentSources.application") },
  { id: "invitation", label: t("enrollmentSources.invitation") },
  { id: "import", label: t("enrollmentSources.import") },
];

export const getEnrollmentSourceLabel = (t) =>
  getEnrollmentSources(t).reduce(
    (acc, source) => ({ ...acc, [source.id]: source.label }),
    {}
  );
